import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' 
import router from './router/index.js'
import axios from 'axios'
import Global from './Global'
import * as echarts from 'echarts'

import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

import Highchart from "highcharts/highcharts";
import HighchartsVue from 'highcharts-vue';
Vue.use(HighchartsVue);
import venn from 'highcharts/modules/venn'


venn(Highchart);




Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.prototype.GLOBAL = Global
Vue.prototype.axios = axios
Vue.prototype.echarts = echarts

new Vue({
  router,
  axios,
  render: h => h(App),
}).$mount('#app')
